import { useContext, useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { InstitutionContext } from '../../../Providers/InstitutionProvider'

const mapToOptions = sector => ({
  label: sector.name,
  value: sector.id,
  tooltip: sector.name,
  entity: sector
})

const SectorsSelector = ({ disabled, empty = false, fallbackToContext = true, multiple = false, sectors = [], values, placeholder, onChange, filter, style = {} }) => {
  const ic = useContext(InstitutionContext)

  const localSectors = sectors.length > 0 || !fallbackToContext || !ic ? sectors : ic.sectors

  const sectorOptions = useMemo(() => typeof filter === 'function'
    ? localSectors.filter(filter).map(mapToOptions)
    : localSectors.map(mapToOptions)
  , [localSectors, filter])

  return (
    <EntitiesSelector
      placeholder={placeholder}
      disabled={disabled}
      empty={empty}
      entityOptions={sectorOptions}
      multiple={multiple}
      values={values}
      style={{ ...style }}
      onChange={onChange}
    />
  )
}

export default SectorsSelector
